import React from 'react';
import { isAndroidDevice, isIOSDevice } from 'utils/deviceInfoUtils';
import { IconButton, Stack } from '@mui/material';
import { ResponsiveSVG } from 'components/ResponsiveSVG/ResponsiveSVG';
import {
  getAppStoreLink,
  getPlayStoreLink,
  useCobrand,
} from 'features/cobrand/hooks/useCobrandUtils';
import playStoreImg from '../../assets/images/resources/playstore.png';
import appStoreImg from '../../assets/images/resources/appstore.png';

export const AppStoreButtons = () => {
  const { cobrand } = useCobrand();
  const storeButtons = [
    {
      img: appStoreImg,
      alt: 'Download on the App Store',
      show: !isAndroidDevice(), // Hide iOS App Store on all Android devices (phones & tablets)
      id: 'app-store',
      href: getAppStoreLink(cobrand),
    },
    {
      img: playStoreImg,
      alt: 'Get it on Google Play',
      show: !isIOSDevice(),
      id: 'play-store',
      href: getPlayStoreLink(cobrand),
    },
  ];

  const handleStoreButtonClick = (href: string) => {
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      id="resources__store-buttons"
      role="group"
      aria-label="Download app buttons"
    >
      {storeButtons.map(
        ({ img, alt, show, id, href }) =>
          show && (
            // TODO: Handle onClick in the Cobrand ticket https://wellframe.atlassian.net/browse/WFMOB-15153
            <IconButton
              key={alt}
              id={`resources__${id}-button`}
              disableRipple
              sx={{ p: 0 }}
              aria-label={alt}
              aria-hidden={!show}
              onClick={() => handleStoreButtonClick(href)}
            >
              <ResponsiveSVG
                imageStyle={{ borderRadius: '6px' }}
                svg={img}
                alt={alt}
                deviceWidth={{ mobile: '132px', tablet: '184px', desktop: '205px' }}
              />
            </IconButton>
          ),
      )}
    </Stack>
  );
};
